import { render, staticRenderFns } from "./GreenFitOutComments.vue?vue&type=template&id=47f408fb&scoped=true&"
import script from "./GreenFitOutComments.vue?vue&type=script&lang=js&"
export * from "./GreenFitOutComments.vue?vue&type=script&lang=js&"
import style0 from "./GreenFitOutComments.vue?vue&type=style&index=0&id=47f408fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f408fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f408fb')) {
      api.createRecord('47f408fb', component.options)
    } else {
      api.reload('47f408fb', component.options)
    }
    module.hot.accept("./GreenFitOutComments.vue?vue&type=template&id=47f408fb&scoped=true&", function () {
      api.rerender('47f408fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/greenFitOut/GreenFitOutComments.vue"
export default component.exports